/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Wizard_Toast_Team_AddedInputs */



/**
* | output |
* | --- |
* | "Team added successfully" |
*
* @param {Spaces_Wizard_Toast_Team_AddedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_wizard_toast_team_added = /** @type {((inputs?: Spaces_Wizard_Toast_Team_AddedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Wizard_Toast_Team_AddedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Team erfolgreich hinzugefügt")
	return /** @type {LocalizedString} */ ("Team added successfully")
});